// src/internal/components/language-switch/language-switch.tsx
import { InternationalIcon } from "@clara/icons";
import { LocaleLangSwicth } from "@clara/locale";
import { Picker, PickerButton, PickerList } from "@clara/picker";
import { jsx, jsxs } from "react/jsx-runtime";
function LanguageSwitch(props) {
  return /* @__PURE__ */ jsx(LocaleLangSwicth, { ...props, children: ({ lang, languages, changing, onChange }) => /* @__PURE__ */ jsxs(
    Picker,
    {
      value: lang,
      options: languages.map((l) => ({
        label: l.label,
        value: l.id
      })),
      onChange: (id) => {
        console.log(id);
        onChange(String(id));
      },
      children: [
        /* @__PURE__ */ jsx(
          PickerButton,
          {
            leftIcon: /* @__PURE__ */ jsx(InternationalIcon, { fontSize: "small" }),
            isLoading: changing
          }
        ),
        /* @__PURE__ */ jsx(PickerList, {})
      ]
    }
  ) });
}

export {
  LanguageSwitch
};
